module.exports = __webpack_public_path__ + "static/media/Quiz_Card.0b662893.png";